export default class Version {
    constructor (dto) {
        this.documentId = 0;
        this.autor = '';
        this.date = '';
        this.text = '';
        this.versionNumber = '';

        if (dto) {
            this.documentId = dto.ObjectID;
            this.autor = dto.Autor;
            this.date = dto.Date;
            this.text = dto.Text;
            this.versionNumber = dto.VersionNumber;
        }
    }
}
